<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-cause" class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :disabled="disabled || this.disabledCondition"
      id="form-pass-cause"
      class="form-control"
      @input="emit"
      @change="emit"
      @blur="emit"
    >
      <option v-for="item in availableItems" v-bind:key="item.id" :value="item.id">{{ item.name }}</option>
    </select>

    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'PaymentTypeInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Способ оплаты услуг'
    },

    inputName: {
      default: 'payment_type_id'
    },

    inputHint: {
      default: undefined
    },

    items: {
      type: [Array, Object],
      default: () => []
    },

    applicationPurposes: {}
  },

  created() {
    let currentValue = this.items.find((item) => item.id === this.inputValue)

    if (this.isDuplicate && Number(currentValue.visible) === 0) {
      this.inputValue = null
    }
  },

  computed: {
    disabledCondition() {
      return this.availableItems.length === 1
    },

    availableItems() {
      if (this.isView) {
        return this.items
      }

      return this.items.filter((item) => Number(item.visible) === 1)
    }
  },

  watch: {
    items(items) {
      if (items.length === 1) {
        this.inputValue = items[0]?.id
      }
    }
  }
}
</script>
